export default __webpack_public_path__ + "static/media/IMG_5564.c4ac5bf1.jpg";